import { hasValue } from 'utils/hasValue';

type Props = {
  secondsUntilExpiry: number | null;
  validitySeconds: number;
  className?: string;
};

export const ExchangeRateRefreshIndicator = ({
  secondsUntilExpiry,
  validitySeconds,
  className = 'size-3'
}: Props) => {
  if (!hasValue(secondsUntilExpiry)) return null;

  const progress = Math.min(
    Math.max(
      ((validitySeconds - secondsUntilExpiry) / validitySeconds) * 100,
      0
    ),
    100
  );

  return (
    <span
      aria-hidden="true"
      className={`inline-block shrink-0 rounded-full transition-[background] duration-300 ${className}`}
      title={`Rate expires in ${secondsUntilExpiry} seconds`}
      style={{
        background: `conic-gradient(currentColor ${progress}%, transparent 0)`,
        mask: 'radial-gradient(farthest-side, transparent calc(100% - 2px), #000 0)',
        WebkitMask:
          'radial-gradient(farthest-side, transparent calc(100% - 2px), #000 0)'
      }}
    />
  );
};
